import React, {useState, useEffect} from 'react';
import { getDocs , collection , db , setDoc , doc , deleteDoc } from '../../firebase';
import SideBar from '../components/Sidebar';
import sidebar_menu from '../components/sidebar-menu';


function Places (  ) {
  
    const [ supportedPlacesArray , setSupportedPlacesArray ] = useState([]);

    const [addShow , setAddShow] = useState(false);
    const [showTable , setTableShow] = useState(true);

    const [updateShow , setUpdateShow] = useState(false);
    const [ deleteShow , setDeleteShow] = useState(false);

    const [success , setSuccess ] = useState(false);

    const [error , setError ] = useState('');

    const [ placeHeadline , setPlaceHeadline ] = useState('');
    const [placePhoto , setPlacePhoto ] = useState('');
    const [placeDesc , setPlaceDesc] = useState('');



    const [ placeId , setPlaceId ] = useState('');


    const makeid = (length) =>  {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * 
     charactersLength));
       }
       return result;
    }

    useEffect(  () => {
        window.scrollTo(0 , 0);
        
        const getSupportedPlaces = async () => { 
          const querySnapshot = await getDocs(collection(db, "supported_places"));
          const placesDataArray = querySnapshot.docs
          .map((doc) => ({ ...doc.data(), id: doc.id }));
            
          setSupportedPlacesArray(placesDataArray);
         
        }
        getSupportedPlaces();
      } , []);

  




    const addNewPlace =  async (e) => {

        e.preventDefault();



        if (placeHeadline === ''  ) {
          setError(' يرجى ادخال اسم المكان ');
    }
    
    
    if (placePhoto === ''  ) {
    setError('  يرجى ادخال صورة المكان  ');
    }
    
    if (placeDesc === ''  ) {
    setError('  يرجى ادخال وصف المكان  ');
    }
    

    
        if (placeHeadline !== '' && placeDesc !== '' && placePhoto !== '' ) {

            const supported_places = await setDoc(doc(db, "supported_places", makeid(20)), {

              place_headline: placeHeadline,
              place_desc: placeDesc,
              place_photo: placePhoto,

             
              });

            
                setSuccess(true);
                setError('');

                setTimeout(() => {
                    setSuccess('');
                    window.location.reload();
                } , 1350);

             

        }
    }

    const updateShownMethod = ( name , photo , desc  , id ) => {

        setPlaceHeadline(name);
        setPlaceDesc(desc);
        setPlacePhoto(photo);
        setPlaceId(id);
    
    
    
        determineShow('update');
      }

      const deleteShowMethod = ( ) => {

            
        determineShow('delete');
      }

    const determineShow = ( param ) => {

        switch(param) {
            
            case 'show':
                setPlaceHeadline('');
                setPlaceDesc('');
                setPlacePhoto('');
                setTableShow(true);
                setAddShow(false);
                setUpdateShow(false);
                setDeleteShow(false);
                break;

            case 'update':
                setTableShow(false);
                setAddShow(false);
                setUpdateShow(true);
                setDeleteShow(false);
                break;

            case 'delete':
                setTableShow(false);
                setAddShow(false);
                setUpdateShow(false);
                setDeleteShow(true);
                break;

            case 'add':
                setTableShow(false);
                setAddShow(true);
                setUpdateShow(false);
                setDeleteShow(false);
                break;
        }
    }

    const updateRecord = async (e) => {
        e.preventDefault();
        const docRef = doc(db, "supported_places", placeId);
    
    const data = {

        place_headline: placeHeadline,
        place_desc: placeDesc,
        place_photo: placePhoto,
    };
    
    if (placeHeadline === ''  ) {
      setError(' يرجى ادخال اسم المكان ');
}

if (placeDesc === ''  ) {
setError('  يرجى ادخال وصف المكان  ');
}

if (placePhoto === ''  ) {
setError('  يرجى ادخال صورة المكان  ');
}



    if (error === '') {
        setDoc(docRef, data)
    
        setSuccess(true);
        setTimeout(() => {
            setSuccess('');
            determineShow('show');
        } , 1350);
    }

  
    
    
      }

      const deleteRecord = async (e) => {
        e.preventDefault();
      
        await deleteDoc(doc(db, "supported_places", placeId));
        setSuccess(true);
        setTimeout(() => {
            setSuccess('');
            determineShow('show');
        } , 1350);
      }
  
      
   

    return(
      <div className="main_admin">

    <div className="sidebar_admin">
    <SideBar menu={sidebar_menu} />
    </div>

    <div className="content_admin">
    <div className='dashboard-content'>
            

            <div className='dashboard-content-container'>

            {addShow && (
                <>
                <div className='dashboard-content-header'>

                <h2 className='admin_headline' >اضافة مكان للموقع  </h2>
                <div className='dashboard-content-search'>
                    
                <button className="dashbord-header-btn_2" onClick={() => determineShow('show') } >رؤية جميع المواقع</button>
                    </div>           

                </div>

                {error && (
                            <>
                            <h1 className="my-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}
                          
                <form onSubmit={addNewPlace} >

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> اسم الموقع </label>
               
                <input value={placeHeadline} onChange={ (e) => setPlaceHeadline(e.target.value)  } type="text" id='name' className="input_form" placeholder='اسم الموقع...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> وصف الموقع </label>
               
                <input value={placeDesc} onChange={ (e) => setPlaceDesc(e.target.value)  } type="text" id='name' className="input_form" placeholder='وصف الموقع...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> صورة الموقع </label>
               
                <input value={placePhoto} onChange={ (e) => setPlacePhoto(e.target.value)  } type="text" id='name' className="input_form" placeholder='صورة الموقع ...' />
            </div>



     

            <button  type='submit' className="dashbord-header-btn_2 w-80">اضافة العلامة</button>


            </form>
                </>

            )}
            
            {updateShow && (
              <>
                <div className='dashboard-content-header'>

                <h2 className='admin_headline' >اضافة مكان للموقع  </h2>
                <div className='dashboard-content-search'>
                    
                <button className="dashbord-header-btn_2" onClick={() => determineShow('show') } >رؤية جميع المواقع</button>
                    </div>           

                </div>

                {error && (
                            <>
                            <h1 className="my-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}
                          
                <form onSubmit={updateRecord} >

                <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> اسم الموقع </label>
               
                <input value={placeHeadline} onChange={ (e) => setPlaceHeadline(e.target.value)  } type="text" id='name' className="input_form" placeholder='اسم الموقع...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> وصف الموقع </label>
               
                <input value={placeDesc} onChange={ (e) => setPlaceDesc(e.target.value)  } type="text" id='name' className="input_form" placeholder='وصف الموقع...' />
            </div>

            <div className="action_form_div">
            <label htmlFor="name" className="label_form mx-1 mb-1"> صورة الموقع </label>
               
                <input value={placePhoto} onChange={ (e) => setPlacePhoto(e.target.value)  } type="text" id='name' className="input_form" placeholder='صورة الموقع ...' />
            </div>



     

            <button  type='submit' className="dashbord-header-btn_2 w-80">تعديل الموقع</button>


            </form>
                </>

            )}
            
            {deleteShow && (
                <>
                <div className='dashboard-content-header'>

                <h2 className='admin_headline' > حذف العلامة </h2>
                <div className='dashboard-content-search'>

                <button className="dashbord-header-btn_2" onClick={() => determineShow('show') } >رؤية جميع المواقع</button>
                    </div>           

                </div>

                {error && (
                            <>
                            <h1 className="my-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}
                          
                <form onSubmit={deleteRecord} >

              
          

            <button className="dashbord-header-btn_2 w-80 bg_red" type='submit'  >حذف الموقع</button>


            </form>
                </>

            )}

            {showTable && (
                <>
                <div className='dashboard-content-header'>
                    <h2 className='admin_headline' >قائمة المواقع </h2>
                    <div className='dashboard-content-search'>

                <button className="dashbord-header-btn_2" onClick={() => determineShow('add') } >  اضافة موقع جديد</button>
                    </div>   
                   
                </div>

                {supportedPlacesArray && (
                    <table className='admin_table_dashboard' >
                    <thead>
                        
                        <th className='table_item' >اسم الموقع</th>
                        <th className='table_item'>صورة الموقع</th>

                        <th className='table_item'>التعديل \ الحذف</th>

                    </thead>

                    <tbody>

                        {supportedPlacesArray.map((item , i) => (
                            <tr key={i} >

                         
                            <td className='table_item_sm' > {item.place_headline} </td>
                            <td    > 
                                <img src={item.place_photo} alt="" className="icon_big" />
                             </td>

                          
                            <td className='d-flex-c' >

                            <button className="edit_btn_admin" onClick={() => updateShownMethod(  item.place_headline , item.place_photo , item.place_desc   , item.id   )  }  >تعديل</button>

                            <button className="delete_btn_admin" onClick={() => deleteShowMethod( ) } >حذف</button>
                            </td>

                        </tr>
                        ))}


                    </tbody>

               
                </table>
                )}

              
                </>
            )}
                
             

               
            </div>
        </div>
    </div>

        </div>

    )
}

export default Places;